import { render, staticRenderFns } from "./BookableCard.vue?vue&type=template&id=6abb8c74&scoped=true&"
import script from "./BookableCard.vue?vue&type=script&lang=js&"
export * from "./BookableCard.vue?vue&type=script&lang=js&"
import style0 from "./BookableCard.vue?vue&type=style&index=0&id=6abb8c74&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abb8c74",
  null
  
)

export default component.exports